import { useDispatch, useSelector } from "react-redux"
// import { isMobile } from "react-device-detect"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
  VirtualizeAutoComplete,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  Autocomplete,
  AutocompleteItem,
  useDisclosure,
} from "@nextui-org/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFilter,
  faMagnifyingGlass,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons"
import { resetReportDetail, setInvoiceDetail } from "../../state/invoiceSlice"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"

import { useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import { enum_Report_Type } from "../report/ReportUtility"
import ReportViewer from "../report/ReportViewer"
import { useNavigate } from "react-router-dom"
import { resetPayVoutDetail } from "../../state/paymentEntrySlice"
import { resetRecVouDetail } from "../../state/receiveEntrySlice"


const SalesData = () => {
  let disapatch = useDispatch()
  const enum_filterFieldId = {
    account: "accountId",
    party: "partyId"
  }
  let { compCode, yearId } = useSelector((state) => state.company)
  const { user,token } = useSelector((state) => state.auth)
  //const navigate=useNavigate();
  //const [data, setData] = useState([])

  let [selectedAccount, setSelectedAccount] = useState("")
  // {
  //   key: "",
  //   value: ""
  // }
  let [selectedParty, setSelectedParty] = useState("")
  // ({
  //   key: "",
  //   value: ""
  // })
  let [filterDate, setFilterDate] = useState({
    start: null,
    end: null,
  })
  const {
    isOpen: isOpenReportModel,
    onOpen: onOpenReportModel,
    onOpenChange: onOpenReportModelChange,
  } = useDisclosure()
  
  
  const { isError: isErrorFetch, data: itemMasterData = [] } = useFetchWithBody({
    url: apiRoute.report.masterdata.fetchAccount,
    queryKey: "AccountList",
    inputData: {
      compcode: compCode[0],//.join(","),
    },
  })


  // const handleDataChange = ({ data, isFilter }) => {
  //   //   console.log(data,isFilter)
  //   // if (selectedAccount.key != "0" && selectedAccount.key != "") {
  //   if (isFilter)
  //     setData(data)
  //   else
  //     setData(saleData)
  //   //
  // }

  const {
    isError,
    isPending,
    // data: saleData = [],
    data = [],
    mutate: filterInvoice,
  } = usePost({
    url: apiRoute.report.invoice.fetch,
    queryKey: "Invoice-List",
  })
  //console.log(data, saleData)

  // useEffect(() => {
  //   //console.log(saleData)
  //   if (selectedAccount.key != "0" && selectedAccount.key != "")
  //     setData(saleData)
  // }, [saleData])

  const funInvoiceData = () => {
    filterInvoice({
      data: {
        compcode: compCode.join(","),
        fromdate: null,
        todate: null,
        acid: selectedAccount != null && selectedAccount != "" && selectedAccount != "0" ? selectedAccount : "",
      },
    })

  }

  const handleVirtualizeChanged = (data) => {
    let id = data.id
    if (id == enum_filterFieldId.account) {
      setSelectedAccount({ key: data.selectedKey, value: data.selectedValue })
      // if (saleData && saleData.length <= 0)
      //   funInvoiceData();
    }
    else if (id == enum_filterFieldId.party)
      setSelectedParty({ key: data.selectedKey, value: data.selectedValue })
  }

  let totalAmt = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "invoice_amount",
      }),
    [data]
  )


  const INITIAL_VISIBLE_COLUMNS = [
    "party_name",
    "invoice_no",
    "invoice_amount",
    "invoice_date",
    "account_name",
    "actions",
  ]
  let downloadDataFooter = {
    party_name: "",
    invoice_no: "",
    invoice_amount: "Total: " + totalAmt,
    invoice_date: "",
    account_name: "",
  }
  if (isError || isErrorFetch) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "PARTY NAME",
      uid: "party_name",
      sortable: true,
      //filter:true,
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
      sortable: true,

    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
      sortable: true,
      //filter:true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmt,
      },
    },
    {
      name: "DATE",
      uid: "invoice_date",
      type: COLUMN_TYPE.date,
      sortable: true,
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
      sortable: true,
    },
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
  ]

   const exportColumns = [
    {
      name: "PARTY NAME",
      uid: "party_name",
    },
    {
      name: "BILL NO",
      uid: "invoice_no",
    },
    {
      name: "AMOUNT",
      uid: "invoice_amount",
    },
    {
      name: "DATE",
      uid: "invoice_date",
      type: COLUMN_TYPE.date,
    },
    {
      name: "ACCOUNT",
      uid: "account_name",
    },
    
  ]
  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faReceipt} />,
      onClick: (row) => {
        let obj = {
          token: token,
          comp_code: row.compcode,
          acid: null,
          billno: row.invoice_no,
          billtype: "S",
          db_user: GetLoginCredentialDb(user, yearId)
        }

        disapatch(resetPayVoutDetail())
        disapatch(resetRecVouDetail())
        disapatch(resetReportDetail())
        disapatch(setInvoiceDetail(obj))
        // navigate(linksUrl.report.invoice.rptInvoice)
        onOpenReportModel()
      },
      label: "print",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]


  const handleFilter = () => {

    if (selectedAccount != "0" && selectedAccount != "") {
      filterInvoice({
        data: {
          compcode: compCode.join(","),
          fromdate: filterDate.start
            ? new Date(filterDate.start).toISOString().split("T")[0]
            : null,
          todate: filterDate.end
            ? new Date(filterDate.end).toISOString().split("T")[0]
            : null,
          acid: selectedAccount != null && selectedAccount != "" && selectedAccount != "0" ? selectedAccount : "",
          pacid: selectedParty != null && selectedParty != "" && selectedParty != "0" ? selectedParty : "",
        },
      })
    } else {

      toast.error("Please select Account !", {
        position: "top-center",
      })
    }
  }

  
  const handleResetFilter = () => {
    setFilterDate({
      start: null,
      end: null,
    })
    funInvoiceData()
    setSelectedParty("") //{ key: "", value: "" })
  }
  const reportModel = () => {
    return (
      <div>
        <Modal
          isOpen={isOpenReportModel}
          onOpenChange={onOpenReportModelChange}
          size="xl"
          placement="center"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-row gap-1">
                  Invoice
                </ModalHeader>
                <ModalBody className="overflow-auto ">
                  <div className="flex flex-col">
                    <ReportViewer props_ReportType={enum_Report_Type.SALESINVOICE} />
                  </div>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    )
  }
  return (
    <div>
      <MainContainer
        pageName="Sales Data"
        info={[]}
        breadcrumbs={["Sales", "Sales Data"]}
      >
        <div className="flex felx-wrap mb-2 bg-gray-10 shadow p-3">
          <div className="flex  flex-wrap items-center gap-2 ">
            <div className="flex  items-center gap-2 ">
              <Autocomplete
                size="sm"
                name={enum_filterFieldId.account}
                // isInvalid={errors[item.name]}
                // errorMessage={errors[item.name]}
                label={"Account"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                className="max-w-23"
                isClearable={true}
                variant="bordered"
                isVirtualized
                defaultItems={
                  itemMasterData && itemMasterData.accData ?
                    itemMasterData && itemMasterData.accData
                    : []
                }
                onSelectionChange={setSelectedAccount}
                selectedKey={selectedAccount}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Party_Id}
                  >
                    {list.Party_Name}
                  </AutocompleteItem>
                )}
              </Autocomplete>
              <Autocomplete
                size="sm"
                name={enum_filterFieldId.party}
                label={"Party Name"}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder={"--Select--"}
                className="max-w-23"
                isClearable={true}
                variant="bordered"
                isVirtualized
                defaultItems={
                  itemMasterData && itemMasterData.partyData ?
                    itemMasterData && itemMasterData.partyData
                    : []
                }
                onSelectionChange={setSelectedParty}
                selectedKey={selectedParty}
              >
                {(list) => (
                  <AutocompleteItem

                    key={list.Party_Id}
                  >
                    {list.Party_Name}
                  </AutocompleteItem>
                )}
              </Autocomplete>
            </div>

            {/* date */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label={"Start Date"}
                views={["day", "month", "year"]}
                format="DD/MM/YYYY"
                value={
                  filterDate.start
                    ? dayjs(filterDate.start)
                    : filterDate.start
                }
                onChange={(newValue) => {
                  setFilterDate((prev) => {
                    return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                  })
                }}
                sx={{ width: "145px" }}
                slotProps={{ textField: { size: "small" } }}
              />
              <DatePicker
                label={"End Date"}
                views={["day", "month", "year"]}
                format="DD/MM/YYYY"
                value={
                  filterDate.end ? dayjs(filterDate.end) : filterDate.end
                }
                onChange={(newValue) => {
                  setFilterDate((prev) => {
                    return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                  })
                }}
                slotProps={{ textField: { size: "small" } }}
                sx={{ width: "145px" }}
              />
            </LocalizationProvider>

            <Button
              size="sm"
              color="primary"
              startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
              onPress={handleFilter}
            // isLoading={isPending}
            >
              Search
            </Button>
            <Button
              size="sm"
              style={{ marginLeft: "5px" }}
              color="primary"
              startContent={<FontAwesomeIcon icon={faFilter} />}
              onPress={handleResetFilter}
            >
              Reset Data
            </Button>
          </div>

        </div>
        {reportModel()}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          //handleDataChange={handleDataChange}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          showAdvanceFilter={false}
          downloadFileName="SalesData-List"
          id="SalesData"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default SalesData

// const formatResult = (itemMasterData) => {
//   return (
//     <span style={{ display: "block", textAlign: "left", fontSize: "10.5px" }}>
//       {itemMasterData.Party_Name}
//     </span>
//   )
// }
// const handleOnSelect = (item) => {
//   //  setSelectedAccount(item.Party_Id)
// }
// <div className="mb-3">
//            <ReactSearchAutocomplete
//             items={itemMasterData}
//             fuseOptions={{ keys: ["Party_Name", "Party_Id"] }}
//             resultStringKeyName="Party_Name"
//             showIcon={false}
//             onClear={handleClear}
//             onSelect={handleOnSelect}
//             value={selectedAccount}
//             showItemsOnFocus={true}
//             placeholder="Select Account"
//             autoFocus
//             formatResult={formatResult}
//             styling={{
//               height: "40px",
//               border: "1px solid #dfe1e5",
//               borderRadius: "5px",
//               color:  "#131516" ,
//               placeholderColor: "red",
//               backgroundColor: "#ffffff" ,  //isMobile ? "#ffffff" :
//               iconColor:  "#131516", //isMobile ? "#131516"
//               fontSize: "14px",
//               zIndex: isOpenReportModel ? "0" : "9999",
//             }}
//           />

//         </div>
// const handleClear = () => {
//   setFilterAccount({
//     accountId: "Account",
//     partyId: "Party"
//   })
//   filterInvoice({
//     data: {
//       compcode: compCode.join(","),
//       fromdate: null,
//       todate: null,
//       acid: "0",
//     },
//   })
//}